import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import loaded from '@/scripts/helpers/loaded';

loaded(() => {
    const slideCount = document.querySelectorAll('.swiper-articles-list .swiper-slide').length;
    const swiperArticles = new Swiper('.swiper-articles-list', {
        loop: slideCount > 3,
        centeredSlides: false,
        modules: [Navigation],
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.new-related-articles-section .swiper-nav-mobile .swiper-custom-next',
                    prevEl: '.new-related-articles-section .swiper-nav-mobile .swiper-custom-prev',
                },
            },
            743: {
                slidesPerView: 2,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.new-related-articles-section .swiper-nav-mobile .swiper-custom-next',
                    prevEl: '.new-related-articles-section .swiper-nav-mobile .swiper-custom-prev',
                },
            },
            820: {
                slidesPerView: 2.5,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.new-related-articles-section .swiper-nav-mobile .swiper-custom-next',
                    prevEl: '.new-related-articles-section .swiper-nav-mobile .swiper-custom-prev',
                },
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
                navigation: {
                    nextEl: '.new-related-articles-section .swiper-nav-desktop .swiper-custom-next',
                    prevEl: '.new-related-articles-section .swiper-nav-desktop .swiper-custom-prev',
                },
            }
        },
    });
});
